angular.module("vgresiduos").directive("destinationActions", function () {
	return {
		scope: true,
		controller: "DestinationActionsCtrl",
		controllerAs: "ctrl",
		templateUrl: "views/destination/baseComponents/destinationActions/destinationActions_template.html"
	};
});
